module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/pix-logo-52be9f763ed6e2bc18fbc6fe36a350c7.png";